module.exports = __webpack_public_path__ + "img/016.e06836aa.png";